import React from "react";
import Home from "../pages/Home";
import About from "../pages/About";
import Contact from "../pages/Contact";
import Features from "../pages/Features";
import SupplierOnboarding from "../pages/SupplierOnboarding";
import DynamicModule from "../pages/DynamicModule";
import Pricing from "../pages/Pricing";
import Tutorials from "../pages/Tutorials";
import UserManualViewer from "../pages/UserManualViewer";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
import NotFound from "../pages/NotFound";

export const routesConfig = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/contact", element: <Contact /> },
  { path: "/features", element: <Features /> },
  { path: "/features/supplier-onboarding", element: <SupplierOnboarding /> },
  { path: "/features/:slug", element: <DynamicModule /> },
  { path: "/pricing", element: <Pricing /> },
  { path: "/tutorials", element: <Tutorials /> },
  { path: "/tutorials/user-manual", element: <UserManualViewer /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/terms-of-service", element: <TermsOfService /> },
  { path: "*", element: <NotFound /> }
];
